import React from "react";
import styled from "styled-components";

import Svg from "@/styles/utils/Svg";

type FormCheckboxProps = {
  name: string;
  label: string;
  icons: IIcons;
  onChange: (checked: boolean) => void;
  checked: boolean;
};

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  label,
  icons,
  name,
  onChange,
  checked,
}) => {
  return (
    <CheckboxLabel htmlFor={name}>
      <Checkbox
        id={name}
        name={name}
        defaultChecked={checked}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.checked)
        }
      />
      <Icon data-qa={`checkbox.${name}.icon`}>
        <Svg contents={icons.Checkmark} width={20} height={20} />
      </Icon>
      <CheckboxLabelText
        data-qa={`checkbox.${name}.text`}
        dangerouslySetInnerHTML={{
          __html: label,
        }}
      />
    </CheckboxLabel>
  );
};

export default FormCheckbox;

const Icon = styled.span`
  position: relative;
  display: block;
  height: 20px;
  width: 20px;
  border: solid ${(props: any) => props.theme.borders.checkbox};
  border-color: ${(props: any) => props.theme.colors.checkboxBorder};
  border-radius: ${(props: any) => props.theme.borders.checkboxRadius};
  object-fit: contain;
  cursor: pointer;

  svg {
    display: block;
    position: absolute;
    height: 60%;
    width: 60%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    path {
      stroke: ${(props: any) => props.theme.colors.checkmark};
      opacity: 0;
    }
  }
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })<any>`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  appearance: none;
  opacity: 0;
  z-index: -1;
`;

export const CheckboxLabelText = styled.span`
  display: block;
  margin-left: 15px;
  color: ${(props: any) => props.theme.colors.fontTextSemiLight};
  font-size: ${(props: any) => props.theme.typography.h200};
  a {
    font-weight: 600;
  }
`;

export const CheckboxLabel = styled.label<any>`
  position: relative;
  display: flex;
  align-items: flex-start;
  line-height: 1.2;

  > input:checked + span {
    svg path {
      opacity: 1;
    }
  }

  > input:disabled + span {
    color: ${(props: any) => props.theme.colors.primary};
    cursor: initial;
  }
`;
